import { SectionProps } from '../types';
import { StyledPipaSection } from './style';

export const PipaSection = ({ sectionName }: SectionProps) => {
  return <StyledPipaSection>{sectionName}</StyledPipaSection>;
};

export default PipaSection;
